import { useMemo } from "react";

import EditableTextCell from "@/components/desktop/list/table/cells/TextCell/EditableTextCell";
import EditableTextAreaCell from "@/components/desktop/list/table/cells/TextCell/EditableTextAreaCell";
import CustomProgressBar from "@/components/desktop/progress/CustomProgressBar";

import { formatNumber } from "@/utils/numberFormat";

export function useProgramDetailColumns(lookups, handleSave, editingRowId) {
	return useMemo(
		() => [
			{
				Header: "Ingrediente Activo",
				accessor: "active_ingredient_text",
				width: "10%",
				disableSortBy: true,
			},
			{
				Header: "Dosis 100L",
				accessor: "dose_100l",
				width: "5%",
				meta: { cellClassName: "tdRight" },
				disableSortBy: true,
				Cell: ({ row }) => {
					const rowId = `${row.original.id}_${row.original.application_number}`;
					const isEditing = editingRowId === rowId;

					if (!isEditing) {
						if (row.original.dose_100l == null) return <span>—</span>;
						return (
							<span style={{ fontWeight: 500 }}>
								{formatNumber(row.original.dose_100l)} {row.original.unit_measure}
							</span>
						);
					}
					return (
						<EditableTextCell
							value={row.original.dose_100l}
							row={row}
							fieldName="dose_100l"
							onSave={handleSave}
							inputType="number"
							placeholder="Dosis"
							displayFormatter={(val) => (
								<span style={{ fontWeight: 500 }}>
									{val} {row.original.unit_measure}
								</span>
							)}
						/>
					);
				},
			},
			{
				Header: "Dosis/Ha",
				accessor: "dose_ha",
				width: "5%",
				meta: { cellClassName: "tdRight" },
				disableSortBy: true,
				Cell: ({ row }) => {
					const rowId = `${row.original.id}_${row.original.application_number}`;
					const isEditing = editingRowId === rowId;

					if (!isEditing) {
						if (row.original.dose_ha == null) return <span>—</span>;
						return <span style={{ fontWeight: 500 }}>{formatNumber(row.original.dose_ha / 1000)} Kg</span>;
					}
					return (
						<EditableTextCell
							value={row.original.dose_ha}
							row={row}
							fieldName="dose_ha"
							onSave={handleSave}
							inputType="number"
							placeholder="Dosis/Ha"
							displayFormatter={(val) => <span style={{ fontWeight: 500 }}>{formatNumber(val / 1000)} Kg</span>}
						/>
					);
				},
			},
			{
				Header: "Mojamiento L/Ha",
				accessor: "wetness",
				width: "5%",
				meta: { cellClassName: "tdCenter" },
				disableSortBy: true,
				Cell: ({ value, row }) => {
					const rowId = `${row.original.id}_${row.original.application_number}`;
					const isEditing = editingRowId === rowId;

					if (!isEditing) return <span>{formatNumber(value) || "—"}</span>;
					return <EditableTextCell value={value} row={row} fieldName="wetness" onSave={handleSave} inputType="number" placeholder="L/Ha" />;
				},
			},
			{
				Header: "Observaciones",
				accessor: "observations",
				disableSortBy: true,
				width: "7%",
				Cell: ({ value, row }) => {
					const rowId = `${row.original.id}_${row.original.application_number}`;
					const isEditing = editingRowId === rowId;

					if (!isEditing) return <span>{value || "—"}</span>;
					return (
						<EditableTextAreaCell
							value={value}
							row={row}
							fieldName="observations"
							onSave={handleSave}
							placeholder="Ingrese observaciones..."
							rows={2}
						/>
					);
				},
			},
			{
				Header: "Progreso",
				accessor: "progress_text",
				disableSortBy: true,
				width: "5%",
				Cell: ({ row }) => <CustomProgressBar applicationOrders={row.original.application_orders} />,
			},
		],
		[handleSave, editingRowId],
	);
}
